// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qLGd","questions":"styles_questions__3ZPQl","footer":"styles_footer__E4L9r"};